// Import all vital core JS files..
import '@js/oneui/app'; // oneUI includes jquery

// Jquery stuff
import './bwLoader';

import $api from '@api/api';
import SecondaryNav from '@app/Shared/Layouts/SecondaryNav';
import CallCenterLogs from '@components/CallCenter/Logs';
import callcenterVenues from '@components/DashboardComponents/callcenterVenues';
import campaignSettings from '@components/DashboardComponents/campaignSettings';
import dashboardResources from '@components/DashboardComponents/dashboardResources';
import latestOrders from '@components/DashboardComponents/latestOrders';
import onboardVenues from '@components/DashboardComponents/onboardVenues';
import dashboardClientManagers from '@components/DashboardComponents/successManagers';
import DealRules from '@components/DealComponents/rulesComponent';
import FaqEditor from '@components/FaqEditor';
import BwFilter from '@components/FilterComponent/BwFilters';
import BwField from '@components/FormComponents/field';
import Phone from '@components/FormComponents/Fields/phone';
import BwFloatingFormActions from '@components/Global/BwFloatingFormActions';
import CreateRenderer from '@components/Global/CreateRenderer.vue';
import ItemSelect from '@components/Global/ItemFilter.vue';
import ImportTool from '@components/ImportComponent/import';
import ItemSortOrder from '@components/ItemSortOrder';
import LimboLayout from '@components/Layouts/LimboLayout.vue';
import SideNav from '@components/Layouts/SideNav';
import TopNav from '@components/Layouts/TopNav';
import BwLogs from '@components/LogComponents/BwLogs';
import BwImageManager from '@components/MediaComponents/BwImageManager';
import ImageManager from '@components/MediaComponents/ImageManager';
import MediaCropper from '@components/MediaComponents/mediaCropper';
import MediaManager from '@components/MediaComponents/mediaManager';
import BwHistory from '@components/NotesComponents/BwHistory';
import BwNotes from '@components/NotesComponents/BwNotes';
import GttdOffer from '@components/OfferComponents/gttdOffer';
import OfferRules from '@components/OfferComponents/RulesComponent';
import RefundableItemRow from '@components/OrderItemsComponents/RefundableItemRow';
import CreateMessage from '@components/privateMessage/createMessage';
import CreateAttribute from '@components/ProductComponents/CreateAttribute';
import PromoItemTable from '@components/PromotionComponents/itemTable';
import PromoComponent from '@components/PromotionComponents/PromoComponent';
import BwLoader from '@components/shared/BwLoader';
import BwPagination from '@components/shared/BwPagination';
import SingleListSort from '@components/SingleListSort';
import BwNewModal from '@components/TableComponents/BwNewModal';
import BwTable from '@components/TableComponents/BwTable';
import TransactionHistory from '@components/TransactionComponents/history';
import BwMerchants from '@components/UserComponents/BwMerchants';
import TiptapWysiwyg from '@components/wysiwygComponents/wysiwygextension';
import Bandwango from '@js/bandwango';
import IronClad from '@services/IronClad/api';
import AutoForm from '@components/FormComponents/DynamicForm/AutoForm';
import TypePhone from "@components/FormComponents/DynamicForm/fields/TypePhone";
import SystemMessages from '@components/Layouts/SystemMessages';
import SystemMessage from '@components/Layouts/SystemMessages/SystemMessage';
import TypePassword from "@components/FormComponents/DynamicForm/fields/TypePassword";
import axios from 'axios';
import { BootstrapVue } from 'bootstrap-vue';
import countdown from 'countdown';
import Fuse from 'fuse.js/dist/fuse.js';
import Echo from 'laravel-echo';
import cloneDeep from 'lodash/cloneDeep';
import groupBy from 'lodash/groupBy';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment-timezone';
import Pusher from 'pusher-js';
import { Device } from 'twilio-client';
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';
import Vue from 'vue';

// Vue components
// TODO: don't globablly register components once blade templates are broken up
import VueBootstrapDatetimePicker from 'vue-bootstrap-datetimepicker';
import Multiselect from 'vue-multiselect';
import DateRangePicker from 'vue2-daterange-picker';
import * as VueGoogleMaps from 'vue2-google-maps';
import Draggable from 'vuedraggable';
import { ValidationObserver } from 'vee-validate';

// Named exports
import { successPopup } from '../../assets/js/admin/successPopup';
import VuetifyConfig from './vuetifyConfig';
import { Cloudinary, CldAudio, CldImage, CldVideo } from "cloudinary-vue";
// for dynamic forms
require('@components/FormComponents/DynamicForm/vee-validate');

// for accessing $vuetify in *.php files
// add vuetify: window.Vuetify as part of new Vue({}) if needed
window.Vuetify = VuetifyConfig;
require('jquery-csv');
require('select2');
require('chosen-js');

Vue.use(BootstrapVue);

Vue.use(VueGoogleMaps, {
	load: {
		key: Vue.prototype.$publicMapKey,
		libraries: 'places'
	}
});

Vue.component('date-picker', VueBootstrapDatetimePicker);
Vue.component('multiselect', Multiselect);
window.VueMultiselect = Multiselect;
Vue.component('draggable', Draggable);
Vue.component('date-range-picker', DateRangePicker);
Vue.component('create-renderer', CreateRenderer);
Vue.component('callcenterVenues', callcenterVenues);
Vue.component('campaign-settings', campaignSettings);
Vue.component('latestOrders', latestOrders);
Vue.component('dashboard-resources', dashboardResources);
Vue.component('client-success-managers', dashboardClientManagers);
Vue.component('onboardVenues', onboardVenues);
Vue.component('item-sort-order', ItemSortOrder);
Vue.component('single-list-sort', SingleListSort);
Vue.component('tiptap-wysiwyg', TiptapWysiwyg);
Vue.component('faq-editor', FaqEditor);
Vue.component('bw-filters', BwFilter);
Vue.component('bw-table', BwTable);
Vue.component('item-select', ItemSelect);
Vue.component('bw-new-modal', BwNewModal);
Vue.component('bw-pagination', BwPagination);
Vue.component('bw-loader', BwLoader);
Vue.component('bw-history', BwHistory);
Vue.component('bw-notes', BwNotes);
Vue.component('bw-merchants', BwMerchants);
Vue.component('bw-logs', BwLogs);
Vue.component('media-manager', MediaManager);
Vue.component('media-cropper', MediaCropper);
Vue.component('deal-rules', DealRules);
Vue.component('offer-rules', OfferRules);
Vue.component('bw-field', BwField);
Vue.component('transaction-history', TransactionHistory);
Vue.component('promo-component', PromoComponent);
Vue.component('promo-item-table', PromoItemTable);
Vue.component('create-message', CreateMessage);
Vue.component('create-attribute', CreateAttribute);
Vue.component('import-tool', ImportTool);
Vue.component('bw-image-manager', BwImageManager);
Vue.component('image-manager', ImageManager);
Vue.component('floating-form-actions', BwFloatingFormActions);
Vue.component('bw-phone', Phone);
Vue.component('call-center-logs', CallCenterLogs);
Vue.component('gttd-offer', GttdOffer);
Vue.component('refundable-item-row', RefundableItemRow);
Vue.component('limbo-layout', LimboLayout);
Vue.component('validation-observer', ValidationObserver);
Vue.component('auto-form', AutoForm);
Vue.component('type-phone', TypePhone);
Vue.component('type-password', TypePassword);

// Layout Components
Vue.component('SecondaryNav', SecondaryNav);
Vue.component('SideNav', SideNav);
Vue.component('TopNav', TopNav);
Vue.component('SystemMessage', SystemMessage);
Vue.component('SystemMessages', SystemMessages);

Vue.use(Cloudinary, {
	configuration: {
		cloudName: 'bandwango',
		secure: true
	},
	components: ['CldAudio', 'CldImage', 'CldVideo']
});
Vue.component('cld-image', CldImage);
Vue.component('cld-video', CldVideo);
Vue.component('cld-audio', CldAudio);

// assign to vue prototype for things used in template (not good practice)
// remove this eventually
Vue.prototype.moment = moment;
Vue.prototype.Bandwango = Bandwango;
Vue.prototype.countdown = countdown;

Vue.filter('truncate', Bandwango.truncateFilter);
Vue.filter('nl2br', Bandwango.nl2brFilter);
Vue.filter('phone', Bandwango.phoneFilter);
Vue.directive('phone', Bandwango.phoneDirective);
Vue.filter('money', Bandwango.moneyFilter);
Vue.filter('pretty', Bandwango.prettyFilter);
Vue.directive('money', Bandwango.moneyDirective);

// ..and assign to window the ones that need it
window.Vue = Vue;
window.moment = moment;
window.Bandwango = Bandwango;
window.countdown = countdown;
window.Fuse = Fuse;
window.axios = axios;
window.TwilioDevice = Device;
window.Pusher = Pusher;
window.InportTool = ImportTool;
window.bwApi = $api;
window.cloneDeep = cloneDeep;
window.isEmpty = isEmpty;
window.groupBy = groupBy;
window.IronClad = IronClad;
window.successPopup = successPopup;
window.EventBus = new Vue();
window.intlTelInput = intlTelInput;

// Date Picker defaults
jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
	format: 'YYYY-MM-DD h:mm a',
	useCurrent: false,
	icons: {
		time: 'far fa-clock',
		date: 'far fa-calendar-alt',
		up: 'fas fa-arrow-up',
		down: 'fas fa-arrow-down',
		previous: 'fas fa-chevron-left',
		next: 'fas fa-chevron-right',
		today: 'fas fa-calendar-check',
		clear: 'far fa-trash-alt',
		close: 'far fa-times-circle'
	}
});

window.Echo = new Echo({
	broadcaster: 'pusher',
	key: process.env.MIX_PUSHER_KEY, // 'bandwangolaravel',
	cluster: process.env.MIX_PUSHER_CLUSTER, // 'bandwangolaravelcluster',
	encrypted: true
});
